/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import Text from 'components/Text.jsx';
import Button from 'components/Button.jsx';
import { graphql } from 'react-apollo';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import invariant from 'invariant';
import RemindAPI from 'lib/RemindAPI';
import { showToast, showAPIErrorToast } from 'reducers/toasts';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import MailTo from 'components/MailTo.jsx';

import './styles/AdminBillingOverview.scss';

type Props = {
  showAPIErrorToast: (error: any) => any,
  showToast: (text: string, kind: 'success' | 'error') => any,
  organization?: {
    id: number,
    name: string,
    paid: boolean,
  },
};

class AdminBillingOverview extends React.Component {
  props: Props;

  requestInformation = () => {
    const { organization } = this.props;
    invariant(organization, 'organization cannot be null in click handler');

    return RemindAPI.request(`/organizations/${organization.id}/get_admin_console_promo`, 'post')
      .then(
        () => this.props.showToast('Your request has been sent! We‘ll be in touch', 'success'),
        (error) => (
          error && error.code === 'throttling_error'
            ? this.props.showToast('Your request has been sent! We‘ll be in touch', 'success')
            : this.props.showAPIErrorToast(error)
        ),
      );
  }

  render() {
    const { organization } = this.props;

    if (!organization) {
      return <CenteredLoadingIndicator />;
    }

    if (!organization.paid) {
      console.error('admin billing page - paid only account should to here');
      return <span>Oh, oh. You should not be here, something weird happened.</span>;
    }

    const Mail = (props) =>
      <MailTo to="districts@remind101.com" subject={`${organization.name} - Billing assistance`}>
        {props.children}
      </MailTo>;

    return (
      <div className="AdminBillingOverview">
        <div className="AdminBillingOverview-info">
          <Text element="div" size="medium">
            You are on the <Text weight="semibold">Remind Plus plan</Text> which includes access to the admin console.
          </Text>
          <Text element="div" size="medium">
            Contact our <Mail>Operations team</Mail> to dicuss details about your plan.
          </Text>
        </div>

        <Mail>
          <Button>Contact us</Button>
        </Mail>
      </div>
    );
  }
}

const withOrganization = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      name
      paid
    }
  }`,
  {
    options: ({ params }) => ({
      variables: { organizationId: [params.schoolId || params.districtId] },
    }),
    props: ({ data }) => ({
      organization: data.organizations ? data.organizations[0] : null,
      ...data,
    }),
  }
);

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ showToast, showAPIErrorToast }, dispatch);
}

export { AdminBillingOverview };
export default withOrganization(
  connect(undefined, mapDispatchToProps)(
    AdminBillingOverview
  )
);



// WEBPACK FOOTER //
// ./src/admin/components/AdminBillingOverview.jsx